export default {
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // 浮点数转为字符串，保留指定小数位
    strValueFromDouble(value, fractionDigits) {
      if (isNaN(value)) {
        return ''
      }
      return parseFloat(value).toFixed(fractionDigits)
    },
    // 4字节time_t转换为字符串日期时间
    strDateTimeFromSTime_t(value) {
      return new Date(value * 1000).Format('yyyy-MM-dd hh:mm:ss')
    },
    // 4字节time_t转换为字符串日期
    strDateFromSTime_t(value) {
      return new Date(value * 1000).Format('yyyy-MM-dd')
    },
    // 4字节time_t转换为字符串时间
    strTimeFromSTime_t(value) {
      return new Date(value * 1000).Format('hh:mm:ss')
    },
    // 8字节time_t转换为字符串日期时间
    strDateTimeFromMsTime_t(value) {
      return new Date(value).Format('yyyy-MM-dd hh:mm:ss')
    },
    // 8字节time_t转换为字符串时间
    strDateFromMsTime_t(value) {
      return new Date(value).Format('yyyy-MM-dd')
    },
    // 8字节time_t转换为字符串时间
    strTimeFromMsTime_t(value) {
      return new Date(value).Format('hh:mm:ss')
    },
    // 整型日期转为字符串日期
    strDateFromInt(value) {
      if (!value) {
        return ''
      }

      let strValue = value.toString()
      if (strValue.length !== 8) {
        return ''
      }
      return strValue.slice(0, 4) + '-' + strValue.slice(4, 6) + '-' + strValue.slice(6, 8)
    },
    // 整型日期转为日期
    dateFromInt(value) {
      if (!value) {
        return ''
      }

      let strValue = value.toString()
      if (strValue.length !== 8) {
        return ''
      }

      return new Date(Number(strValue.slice(0, 4)), Number(strValue.slice(4, 6)) - 1, Number(strValue.slice(6, 8)))
    },
    // 日期转为整型
    intFromDate(value) {
      if (!value) {
        return 19700101
      }
      return Number(value.Format('yyyyMMdd'))
    },
    // 字节转换为MB
    mByteFromByte(value, digits) {
      let size = value / (1024 * 1024)
      return size.toFixed(digits)
    },
    // MB转换为字节
    byteFromMByte(value) {
      return parseInt(value * 1024 * 1024)
    },
    // 字节转换为GB
    gByteFromByte(value, digits) {
      let size = value / (1024 * 1024 * 1024)
      return size.toFixed(digits)
    },
    // GB转换为字节
    byteFromGByte(value) {
      return parseInt(value * 1024 * 1024 * 1024)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/convertor-mixin.js